/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/inventory-intro",
  DASHBOARD: "/inventory-dashboard",
  INBOX: "/inventory-inbox",
  OUTBOX: "/inventory-outbox",

  /* Master */

  /* Production */
  INVENTORY_PRODUCTION_ORDER_CREATION: "/production-order-create",
  INVENTORY_PRODUCTION_ORDER_LIST: "/production-order-list",
  INVENTORY_PRODUCTION_ORDER_DETAILS: "/production-order-details",

  //Stock
  INVENTORY_STOCK_LIST: "/stock-list",
  INVENTORY_STOCK_CREATION: "/stock-creation",
  INVENTORY_STOCK_DETAILS: "/stock-details",

  //Warehouse
  INVENTORY_WAREHOUSE_LIST: "/warehouse-list",
  INVENTORY_WAREHOUSE_CREATION: "/warehouse-creation",
  INVENTORY_WAREHOUSE_DETAILS: "/warehouse-details",

  INVENTORY_ORDER_CREATION: "/order-creation",
  INVENTORY_ORDER_DETAILS: "/order-details",
  INVENTORY_ORDER_LIST: "/order-list",



  
});
